import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productCategoriesApi } from "api/api/productCategoriesApi/productCategoriesApi";

export const getProductsCategories = createAsyncThunk<
  any,
  any
>("productCategories/getProductsCategories", async (params, { rejectWithValue }) => {
  try {
    const data = await productCategoriesApi.getProductsCategories(params);
    return data;
  } catch (error: unknown) {
    let message = "Что-то пошло не так... Попробуйте снова";
    if (axios.isAxiosError(error)) {
      console.error("Error while creating category", error.response?.data);
    } else {
      console.error("Error while creating category", error);
    }
    return rejectWithValue(message);
  }
});